import { LOAD_CLIENTS, UNLOAD_CLIENTS, UPDATE_CLIENTS, LOAD_SINGLE_CLIENT, UPDATE_SINGLE_CLIENT } from '../Reducers/Clients';
import EndpointService from '../Service/EndpointService';
import moment from 'moment';
import { fromJS } from 'immutable';

export function updatePassword(user) {

    return (dispatch) => {

        return EndpointService.post('/clientportal/api/change-password', user.toJS()).then((response) => {

            return user;

        })

    }

}


export function getCurrentClient() {

    return dispatch => {

        return new Promise((resolve, reject) => {

            dispatch({ type: LOAD_SINGLE_CLIENT });

            EndpointService.get('/clientportal/api/currentclient').then((response) => {

                dispatch({
                    type: UPDATE_SINGLE_CLIENT,
                    single: fromJS(response.data)
                })

            }).catch(() => {

            })


        })


    }


}